<template>
  <b-alert :show="isResponseError.state"
           dismissible
           fade
           variant="danger">
    <b-icon icon="shield-fill-exclamation"></b-icon>
    {{ isResponseError.message }}
  </b-alert>
</template>

<script>
export default {
  name: 'AlertCard',
  components: {},
  filters: {},
  mixins: {},
  props: {
    isResponseError: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
  .bg-lightgreen {
    background-color: #28a74520;
  }
</style>
